import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import Button from '@mui/material/Button';
import React from 'react';

import { ContactItemDto } from '@/api/generated';
import { DialogFullWidthStyle } from '@/styles/dialog.styles.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { ContactsTable } from '@/views/contacts/components/table/ContactsTable.comp.tsx';
import { ProcessCreateAddContactTableRow } from '@/views/processesCreate/components/ProcessCreateAddContactTableRow.comp.tsx';
import { ProcessAddContactDialogButton } from '@/views/processesDetails/components/dialog/addContact/components/ProcessAddContactDialogButton.comp.tsx';

interface Props {
  onCloseClick: () => void;
  onSelectContact: (customer: ContactItemDto) => void;
  urlStateEnabled?: boolean;
}

export const ProcessAddContactDialog: React.FC<Props> = props => {
  const { onCloseClick: handleCloseClick, onSelectContact, urlStateEnabled } = props;
  const { t } = useTranslationWithPrefix('views.processesUpdate.dialog.addContact');

  return (
    <Dialog open={true} sx={DialogFullWidthStyle}>
      <DialogTitle>{t('title')}</DialogTitle>
      <DialogContent>
        <ContactsTable
          actionsColumns
          additionalButtons={[{ button: ProcessAddContactDialogButton, name: 'addContact' }]}
          customRow={ProcessCreateAddContactTableRow}
          isAlreadyInCustomer={{ label: '', value: true }}
          isOnCustomerDetails={true}
          onCustomAction={onSelectContact}
          pageSize={5}
          tableKey="addContact"
          urlStateEnabled={urlStateEnabled}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseClick} variant="outlined">
          {t('button.close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
